"use strict";
import { memo, useCallback } from "react";
import { Flex, Text, TouchableArea, isWeb } from "ui/src";
import useIsKeyboardOpen from "hooks/useIsKeyboardOpen";
import { dismissNativeKeyboard } from "utilities/src/device/keyboard/dismissNativeKeyboard";
import { KeyAction } from "utilities/src/device/keyboard/types";
import { useKeyDown } from "utilities/src/device/keyboard/useKeyDown";
import { isInterface } from "utilities/src/platform";
import noop from "utilities/src/react/noop";
function _OptionItem({
  image,
  title,
  subtitle,
  rightElement,
  badge,
  titleProps,
  onPress,
  onLongPress,
  disabled,
  testID,
  modalInfo,
  focusedRowControl
}) {
  const isKeyboardOpen = useIsKeyboardOpen();
  const { modal, modalShouldShow, modalSetIsOpen } = modalInfo ?? {};
  const onPressOption = useCallback(() => {
    const handleShowModal = () => {
      dismissNativeKeyboard();
      modalSetIsOpen?.(true);
    };
    if (modalShouldShow && modal) {
      if (isKeyboardOpen && isInterface) {
        const activeElement = document.activeElement;
        activeElement?.blur();
        setTimeout(handleShowModal, 700);
      } else {
        handleShowModal();
      }
      return;
    }
    onPress();
  }, [modalShouldShow, modal, isKeyboardOpen, modalSetIsOpen, onPress]);
  const { focusedRowIndex, rowIndex, setFocusedRowIndex } = focusedRowControl ?? {};
  const keyboardNavEnabled = isWeb && focusedRowControl && setFocusedRowIndex;
  const isFocused = focusedRowIndex !== void 0 && focusedRowIndex === rowIndex;
  useKeyDown({
    keys: ["Enter"],
    keyAction: KeyAction.UP,
    disabled: !keyboardNavEnabled,
    callback: isFocused ? onPressOption : noop,
    shouldTriggerInInput: true
  });
  const focusedStyleProps = keyboardNavEnabled ? {
    backgroundColor: isFocused ? "$surface1Hovered" : void 0,
    onMouseEnter: () => {
      setFocusedRowIndex?.(rowIndex);
    },
    onMouseLeave: () => {
      setFocusedRowIndex?.(void 0);
    }
  } : { hoverStyle: { backgroundColor: "$surface1Hovered" } };
  return <>
      <TouchableArea
    animation="300ms"
    opacity={disabled ? 0.5 : 1}
    width="100%"
    px="$spacing12"
    onPress={onPressOption}
    onLongPress={onLongPress}
  >
        <Flex
    row
    alignItems="center"
    gap="$spacing8"
    justifyContent="space-between"
    p="$spacing8"
    style={{
      pointerEvents: "auto"
    }}
    borderRadius="$rounded16"
    {...focusedStyleProps}
    testID={testID}
  >
          <Flex row shrink alignItems="center" gap="$spacing12">
            {image}
            <Flex shrink>
              <Flex row alignItems="center" gap="$spacing8">
                {typeof title === "string" ? <Text
    color="$neutral1"
    variant="body1"
    whiteSpace="nowrap"
    overflow="hidden"
    textOverflow="ellipsis"
    numberOfLines={1}
    {...titleProps}
  >
                    {title}
                  </Text> : title}
                {badge}
              </Flex>
              {subtitle}
            </Flex>
          </Flex>

          {rightElement && <Flex grow alignItems="flex-end" justifyContent="center">
              {rightElement}
            </Flex>}
        </Flex>
      </TouchableArea>

      {modal}
    </>;
}
export const OptionItem = memo(_OptionItem);
